import { render, staticRenderFns } from "./RightsDetail.vue?vue&type=template&id=06e7ac8e&scoped=true"
import script from "./RightsDetail.vue?vue&type=script&lang=js"
export * from "./RightsDetail.vue?vue&type=script&lang=js"
import style0 from "./RightsDetail.vue?vue&type=style&index=0&id=06e7ac8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7ac8e",
  null
  
)

export default component.exports